import type { EdgeData, NodeId } from '@ipfabric/utils';
import type { GraphEdgeDisplayObject } from '../GraphEdge';

export const refreshEdgeVisibility = (
  edge: GraphEdgeDisplayObject,
  edgeData: EdgeData,
  hiddenNodes: Set<NodeId>,
): void => {
  // Remove reasons to hide if nodes are no longer hidden
  if (
    edge.reasonsToHide.has('SOURCE_NODE_HIDDEN') &&
    !hiddenNodes.has(edgeData.source)
  ) {
    edge.reasonsToHide.delete('SOURCE_NODE_HIDDEN');
  }

  if (
    edge.reasonsToHide.has('TARGET_NODE_HIDDEN') &&
    !hiddenNodes.has(edgeData.target)
  ) {
    edge.reasonsToHide.delete('TARGET_NODE_HIDDEN');
  }

  // Add reasons to hide if nodes became hidden
  if (
    !edge.reasonsToHide.has('SOURCE_NODE_HIDDEN') &&
    hiddenNodes.has(edgeData.source)
  ) {
    edge.reasonsToHide.add('SOURCE_NODE_HIDDEN');
  }

  if (
    !edge.reasonsToHide.has('TARGET_NODE_HIDDEN') &&
    hiddenNodes.has(edgeData.target)
  ) {
    edge.reasonsToHide.add('TARGET_NODE_HIDDEN');
  }
};
